<template>
  <v-dialog v-model="dialogModel" persistent max-width="500">
    <v-card>
      <v-card-text>
        <v-flex>
          <v-alert type="warning" :value="true">
            <h3>Are you sure to make this payment transaction?</h3>
          </v-alert>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" flat @click="dialogModel = false">Cancel</v-btn>
        <v-btn
          color="success"
          large
          outline
          :loading="loading"
          @click="onConfirm"
        >
          Proceed
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["dialog", "loading"],
  data: () => ({
    saleNote: "",
  }),
  computed: {
    dialogModel: {
      get() {
        return this.dialog;
      },
      set() {
        this.$emit("update:dialog");
      },
    },
  },
  methods: {
    onConfirm() {
      this.$emit("confirm");
      // this.dialogModel = false;
    },
  },
};
</script>

<style></style>
